/* eslint-disable react/no-unescaped-entities */

import { Meta } from '@/layout/Meta'
import { Main } from '@/templates/Main'
import { AppConfig } from '@/utils/AppConfig'
import { Cta } from '@/utils/Cta'
import { note } from '@/utils/Note'
import Link from 'next/link'
import { useEffect } from 'react'

const Pricing = () => {
  useEffect(() => {
    note('Visited pricing')
  }, [])

  return (
    <Main meta={<Meta 
        title="Pricing (Free, Pro, or Enterprise) - Dessert Data"
        description="Dessert Data strives to provide low cost access to your data, served just how you like it." />}>
      <h1 className="font-bold text-2xl text-black-700 text-center md:text-left">Pricing</h1>
      <section className="flex mt-10 text-sm flex-col md:flex-row">
        <div className="flex-1 p-5 flex flex-col">
          <h2 className="font-bold text-xl text-sky-700">Free</h2>
          <span className="text-sm italic block">
            Try before you buy.  No credit card required.
          </span>
          <ul className="marker:text-sky-400 list-disc ml-4 text-base flex-1">
            <li>Automatic Refreshes</li>
            <li>Access All Your Data</li>
            <li>White Glove Setup!</li>
          </ul>
          <Cta className='font-bold text-lg w-full'>GET STARTED</Cta>
        </div>
        <div className="flex-1 flex flex-col p-5 bg-blue-100">
          <h2 className="font-bold text-xl text-sky-700">A La Carte</h2>
          <span className="text-sm italic block">
            Set it and forget it.
          </span>
          <span className="m-0 p-0 block">
            $28 monthly
          </span>
          <ul className="marker:text-sky-400 list-disc ml-4 text-base flex-1">
            <li>Everything from Free</li>
            <li className='font-bold'>Scheduled Refreshes</li>
            <li>High Bandwidth</li>
            <li>Paid Tier Support</li>
          </ul>
          <Cta className='font-bold text-lg w-full' location='/checkout/'>PURCHASE</Cta>
        </div>
        <div className="flex-1 p-5 flex flex-col">
          <h2 className="font-bold text-xl text-sky-700">Enterprise</h2>
          <span className="text-sm italic block">
            Customized enterprise service.
          </span>
          <ul className="marker:text-sky-400 list-disc ml-4 text-base flex-1">
            <li>Everything from Paid</li>
            <li>Custom SLA</li>
            <li>Enterprise Hosting Options</li>
            <li>Customizations</li>
          </ul>
          <Cta className='font-bold text-lg w-full' location={`mailto:${AppConfig.email}`}>CONTACT US</Cta>
        </div>
      </section>
    </Main>
  )
}

export default Pricing
